import React from 'react'
import { useHistory } from 'react-router-dom'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'
import AddEnodeDevice from '../addEnodeDevice/AddEnodeDevice'

const SolarPanelOnboarding: React.FC = () => {
	const history = useHistory()

	const goForward = () => history.push('/devices/add-device/solar-panel/setup')

	return (
		<PageWrapper page='addSolarPanel' appBarOptions={{ backPath: '/devices/add-device' }}>
			<AddEnodeDevice goForward={goForward} type='inverter' />
		</PageWrapper>
	)
}

export default SolarPanelOnboarding
